import { render } from "./kakaoLoginComponent.vue?vue&type=template&id=61b03f9c"
import script from "./kakaoLoginComponent.vue?vue&type=script&lang=js"
export * from "./kakaoLoginComponent.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__